import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getPostPageEnabled } from '@wix/communities-blog-client-common';
import { BUTTON_CREATE_POST } from '../../bi-events/bi-buttons';
import { buttonClicked } from '../../actions/button-clicked';
import withAuth from '../../hoc/with-auth';
import withNavigation from '../../hoc/with-navigation';

export class CreatePostHandler extends Component {
  handleClick = () => {
    const {
      categorySlug,
      buttonClicked,
      navigation: { navigateToCreatePost },
      isPostPageEnabled,
      biPage,
    } = this.props;

    buttonClicked({ action: BUTTON_CREATE_POST, biPage });
    navigateToCreatePost(`/create-post${categorySlug ? `?categorySlug=${categorySlug}` : ''}`, isPostPageEnabled);
  };

  handleClickDecorated = (...args) => {
    return this.props.forPublicUser(this.handleClick)(...args);
  };

  render() {
    const { children } = this.props;
    const child = React.Children.only(children);
    return React.cloneElement(child, { onClick: this.handleClickDecorated });
  }
}

CreatePostHandler.propTypes = {
  categorySlug: PropTypes.string,
  children: PropTypes.node.isRequired,
  buttonClicked: PropTypes.func,
  navigation: PropTypes.object,
  forPublicUser: PropTypes.func,
  isPostPageEnabled: PropTypes.bool.isRequired,
  biPage: PropTypes.string,
};

const mapStateToProps = (state) => ({
  isPostPageEnabled: getPostPageEnabled(state),
});

const mapDispatchToProps = {
  buttonClicked,
};

export default flowRight(connect(mapStateToProps, mapDispatchToProps), withNavigation, withAuth)(CreatePostHandler);
